var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11957",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 17.2",
    style: {
      enableBackground: "new 0 0 18 17.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#355D8B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10131",
    className: "st0",
    d: "M18,6.7c0,0.6-0.2,1.2-0.7,1.6c0.5,0.4,0.7,1,0.7,1.6c0,1-0.8,1.9-1.8,2c0,0-0.1,0-0.1,0h-4.3 v2.7c0.1,1.5-1.1,2.7-2.5,2.7c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.2-0.4-0.4v-3l-1.5-2.2l-1.7-1.3v1c0,0.2-0.2,0.4-0.4,0.4H0.4 c-0.2,0-0.4-0.2-0.4-0.4v-11C0,0.2,0.2,0,0.4,0h4.7c0.2,0,0.4,0.2,0.4,0.4v0.3C5.8,0.3,6.2,0.1,6.7,0h8.6c0.6,0,1.2,0.2,1.6,0.7 c0.6,0.7,0.7,1.7,0.2,2.5C17.7,3.3,18,3.8,18,4.3c0,0.5-0.2,1-0.5,1.4C17.8,5.9,18,6.2,18,6.7z M4.7,0.8H0.8V11h3.9V0.8z M15.3,6.3 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4H16c0.6,0,1.1-0.4,1.2-1.1c0,0,0-0.1,0-0.1c0-0.3-0.2-0.4-1.2-0.4h-1.6 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4H16c0.4,0,0.6-0.5,0.6-1c0-0.3-0.1-0.7-0.3-0.9c-0.3-0.3-0.7-0.4-1.1-0.4H6.7 c-0.3,0-0.9,0.7-1.2,1.3v7.3L7.7,11c0,0,0.1,0.1,0.1,0.1l1.6,2.3c0,0.1,0.1,0.1,0.1,0.2v2.7c0.9-0.1,1.6-1,1.6-1.9v-3.1 c0-0.2,0.2-0.4,0.4-0.4H16c0.6,0,1.2-0.5,1.2-1.1c0-0.6-0.5-1.2-1.1-1.2c0,0,0,0-0.1,0h-1.3c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4 c0,0,0,0,0,0H16c0.6,0,1.1-0.4,1.2-1.1c0,0,0-0.1,0-0.1c0-0.3-0.2-0.4-1.2-0.4L15.3,6.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10132",
    className: "st0",
    d: "M2.7,2c0.4,0,0.8,0.3,0.8,0.7c0,0.4-0.3,0.8-0.7,0.8C2.4,3.5,2,3.2,2,2.8C1.9,2.4,2.2,2,2.7,2z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs_down.1ab267e5adbcc4c52c6510b993a6d73c.svg";
export { ForwardRef as ReactComponent };